import {RangeDatePicker as RangeDatePickerBase, RangeDatePickerProps} from '@logistics-frontend/blocks'
import {RangeValue} from '@react-types/shared'
import {useFormikContext} from 'formik'

import {useConnectedRangeDatePicker} from '../hooks'

type RangeDatePickerFormProps = Omit<
  RangeDatePickerProps,
  'name' | keyof ReturnType<typeof useConnectedRangeDatePicker>
> & {
  name: RangeValue<string>
}

type RemoveNullValues<T> = Record<keyof T, Exclude<T[keyof T], null>>

export const RangeDatePicker = function RangeDatePicker({name, ...props}: RangeDatePickerFormProps) {
  const formContext = useFormikContext()
  const {value, ...connectedProps} = useConnectedRangeDatePicker(formContext, name)

  const appliedValue = !!value.start && !!value.end ? (value as RemoveNullValues<typeof value>) : null

  return <RangeDatePickerBase {...props} {...connectedProps} value={appliedValue} />
}
